import React from "react";
import { ScrollBarSpacer, ScrollWindow } from './Scrollview.styles';
import { ScrollviewProps } from './Scrollview.types';

export const Scrollview: React.FC<ScrollviewProps> = ({ $MaxSize = 200, children }) => {
  return (
    <ScrollWindow $MaxSize={$MaxSize} autoHide={false}>
      <ScrollBarSpacer>
        {children}
      </ScrollBarSpacer>
    </ScrollWindow>
  )
}